import type { TkDict } from "./types";

const dict: TkDict = {
  uz: {
    "tk.detail.crumbs_label": "Sahifa yo'li",
    "tk.detail.device_label": "Ko'rinish rejimi",
    "tk.detail.fullscreen": "To'liq ekranda ochish",
    "tk.detail.preview_note": "Mehmonlaringiz taklifnomani aynan shunday ko'radi",
    "tk.detail.customize_hint": "Ko'rinishda darhol aks etadi",
    "tk.detail.features_label": "Har bir taklifnomada",
    "tk.detail.related_1": "Sizga",
    "tk.detail.related_2": "yoqishi mumkin",
  },
  ru: {
    "tk.detail.crumbs_label": "Навигационная цепочка",
    "tk.detail.device_label": "Режим просмотра",
    "tk.detail.fullscreen": "Открыть на весь экран",
    "tk.detail.preview_note": "Гости увидят приглашение именно так",
    "tk.detail.customize_hint": "Сразу видно в превью",
    "tk.detail.features_label": "В каждом приглашении",
    "tk.detail.related_1": "Вам может",
    "tk.detail.related_2": "понравиться",
  },
  en: {
    "tk.detail.crumbs_label": "Breadcrumb",
    "tk.detail.device_label": "Preview mode",
    "tk.detail.fullscreen": "Open full screen",
    "tk.detail.preview_note": "Your guests will see the invitation exactly like this",
    "tk.detail.customize_hint": "Updates the preview instantly",
    "tk.detail.features_label": "Included with every invitation",
    "tk.detail.related_1": "You may also",
    "tk.detail.related_2": "like",
  },
};

export default dict;
